export default {
  LEADS_OVERVIEW: 'Presentatie van de vooruitzichten',
  TOTAL_LEADS: 'Aantal totale vooruitzichten',
  HOT_LEADS: 'Pistes chaudes',
  WARM_LEADS: 'Des pistes chaleureuses',
  COLD_LEADS: 'De pistes van froides',
  NO_RECORDS_FOUND: 'Aucun inschrijving trouvé',
  DETAILS: 'Details',
  CATEGORY: 'Categorie',
  SCAN_DATE_N_TIME: 'Datum en heure de numerisatie',
  FILTER: 'filteren',
  ALL: 'Aan ons',
  HOT: 'Chaud',
  WARM: 'Chaud',
  COLD: 'Froid',
  SELECT_DATES: 'selecteer data',
  SEARCH_LEADS: 'zoek naar leads',
  SCANNED_BY: 'gescand door',
  FILES_INFO_SHARED: 'Bestanden en informatie gedeeld',
  IMAGES: 'Afbeeldingen',
  NOTE: 'Opmerking',
  DELETED_FILE_MSG: 'Dit bestand is verwijderd',
  LEAD_DETAILS: 'Leadgegevens',
  ANONYMISE_DAYS: 'De leadgegevens worden binnen {days} dagen geanonimiseerd.'
}
